import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, HostBinding, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from '@bcef/ia-components/buttons';
import { IconsModule } from '@bcef/ia-ng-icons';
import { DataLayer } from '@difa/ia-data-layer';

import { ApiErrorMessage } from '@features/succession/interfaces';
import { SuccessionFacade } from '@features/succession/succession.facade';

@Component({
  selector: 'ia-succession-error',
  templateUrl: './error.component.html',
  imports: [AsyncPipe, ButtonModule, IconsModule],
  standalone: true,
})
export class ErrorComponent implements OnInit, AfterViewInit {
  @HostBinding('class') public classAttribute = 'tw-flex tw-flex-col tw-my-4 tw-mx-24';

  private readonly route = inject(ActivatedRoute);

  protected readonly successionFacade = inject(SuccessionFacade);

  private readonly router = inject(Router);

  private readonly dataLayer = inject(DataLayer);

  public error: ApiErrorMessage = this.route.snapshot.data['error'];

  public ngOnInit(): void {
    if (!this.error) {
      this.router.navigate(['/']);
    }
  }

  public ngAfterViewInit(): void {
    this.dataLayer.add(`dataLayer.${this.error.code}`);
  }
}
